import { calcularImpuesto } from "./calcularImpuesto";

// ─── Grosseo CapEx (ÚNICA fuente, regla 10.1) ────────────────────────────────
// El BRUTO que debe salir por caja para una línea CapEx (activo suelto o cuota de
// activo). La inversión se CAPITALIZA al neto (activos.costo_unitario) — este helper
// NO toca ese neto: solo calcula lo que se PROYECTA/concilia en caja, que sí sale con IVA.
//
// Regla (idéntica en Futuros y en el modal de vinculación, CapEx-IVA Fase 2):
//   bruto = (exento_iva || moneda ≠ local del país) ? neto
//                                                    : neto + calcularImpuesto(neto, pais).impuesto
//
// Por qué la moneda: los importados (FOB/transporte en USD) no llevan IVA local, así que
// una línea cuya moneda no es la local del país queda en neto. Reusa el util canónico
// calcularImpuesto (Chile 0,19 / Perú 0,18) — no se define tasa nueva (reglas 10.19/10.27).
export const monedaLocalDePais = (pais) => (pais === "Perú" ? "PEN" : "CLP");

export const capexLlevaIvaLocal = (moneda, pais, exento_iva) => !exento_iva && moneda === monedaLocalDePais(pais);

// Devuelve el bruto (número, misma moneda que el neto). `opts`: { exento_iva, moneda, pais }.
export const brutoCapex = (neto, { exento_iva, moneda, pais } = {}) => {
  const n = Number(neto || 0);
  if (!n || !capexLlevaIvaLocal(moneda, pais, exento_iva)) return n;
  return n + calcularImpuesto(n, pais).impuesto;
};
